import { Logger as beaverLogger } from 'beaver-logger'

const logger = beaverLogger({
  // Url to send logs to
  url: '/merchant-lending/loanbuilder/log',

  // Prefix to prepend to all events
  prefix: 'PPBL',
})

const clientLogger = {
  info: (message, data = {}) => {
    logger.info('BROWSER_CLIENT_INFO', {
      message,
      debugInfo: data,
    })
  },
  warn: (message, error = {}) => {
    logger.warn('BROWSER_CLIENT_WARNING', {
      message,
      error,
    })
  },
  error: (message, error = {}) => {
    logger.error('BROWSER_CLIENT_ERROR', {
      message,
      error,
    })
  },
  cleverError: (message, error = {}) => {
    logger.error('CLEVER_TOOL_ERROR', {
      message,
      error,
    })
  },
  cleverInfo: (message, error = {}) => {
    logger.info('CLEVER_TOOL_INFO', {
      message,
      error,
    })
  },
}

export default clientLogger
